import { BaseService } from '../api';
import { SUBSCRIPTIONS_V4_BASE_URL } from '../subscriptions';

export class ExtrasService extends BaseService {
  getExtras = async subscriptionId =>
    await this.client.get(
      `${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/extras/`,
    );

  updateSubscriptionExtras = async (subscriptionId, extras) =>
    await this.client.put(
      `${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/add_extras/`,
      extras,
    );

  deleteSubscriptionExtra = async (subscriptionId, extraId) =>
    await this.client.delete(
      `${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/extras/${extraId}/`,
    );
}
